import { render, staticRenderFns } from "./ExternalAddAddressPage.vue?vue&type=template&id=24bc287d&"
import script from "./ExternalAddAddressPage.vue?vue&type=script&lang=ts&"
export * from "./ExternalAddAddressPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports